import { Component } from '@angular/core';

@Component({
  selector: 'app-gigworker',
  templateUrl: './gigworker.component.html',
  styleUrls: ['./gigworker.component.css']
})
export class GigworkerComponent {
ShowCard:any;
}
